import { Box, FormControl } from '@primer/react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../components/ui/button';
import Modal from '../../../components/ui/modal';
import ModalActions from '../../../components/ui/modal/ModalActions';
import Text from '../../../components/ui/text';
import TextInput from '../../../components/ui/text-input';
import { useCommonContext } from '../../../contexts/common';
import { useCommonSelectedHook } from '../../../hooks/useCommonSelectedHook';
import { ePageBaseStatus } from '../../../models/ePageBaseStatus';
import { ITrangThaiDangKyAn } from '../../../models/response/category/ITrangThaiDangKyAn';
import { actions } from '../../../state/actions/actionsWrapper';
import { RootState } from '../../../state/reducers';

const TrangThaiDangKyAnEditModal = () => {
    const { status, editingData } = useSelector((x: RootState) => x.danhMucWrapper.trangThaiDangKyAn);

    const dispatch = useDispatch();
    const { dm_coso_id } = useCommonSelectedHook();
    const { translate } = useCommonContext();

    const { register, handleSubmit, formState: { errors } } = useForm<ITrangThaiDangKyAn>({
        defaultValues: editingData ? {
            ...editingData,
        } : undefined
    });

    const onSubmit = async (data: ITrangThaiDangKyAn) => {
        dispatch(actions.danhMucWrapper.trangThaiDangKyAn.SAVE_START({
            ...data,
            id: data?.id ?? 0,
            dm_coso_id: dm_coso_id
        }));
    };

    return (
        <Modal isOpen
            title={editingData ? "Base.Label.Edit" : "Base.Label.AddNew"}
            onClose={() => {
                dispatch(actions.danhMucWrapper.trangThaiDangKyAn.CLOSE_EDIT_MODAL(undefined));
            }}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ display: "grid", gap: 2 }}>
                    <FormControl>
                        <FormControl.Label><Text text='Trạng thái' /></FormControl.Label>
                        <TextInput block
                            name="trang_thai"
                            register={register}
                            errors={errors}
                            required
                            validateMessage={`${translate("Base.Form.RequiredMessage")} ${translate("trạng thái")}`}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label><Text text='Trạng thái (EN)' /></FormControl.Label>
                        <TextInput block
                            name="trang_thai_en"
                            register={register}
                            errors={errors}
                        />
                    </FormControl>
                </Box>
                <ModalActions>
                    <Button text='Base.Label.Close' onClick={() => {
                        dispatch(actions.danhMucWrapper.trangThaiDangKyAn.CLOSE_EDIT_MODAL(undefined));
                    }} />
                    <Button text={editingData ? "Base.Label.Update" : "Base.Label.AddNew"} variant='primary' type='submit'
                        isLoading={status === ePageBaseStatus.is_saving}
                    />
                </ModalActions>
            </form>
        </Modal>
    );
};

export default TrangThaiDangKyAnEditModal;
